let allComponents = {}

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // The relative path of the components folder
  '.',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /\w+\.(vue)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Strip the leading `'./` and extension from the filename
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')

  allComponents = { ...allComponents, [componentName]: componentConfig.default || componentConfig }
})

export default allComponents


// WEBPACK FOOTER //
// ./src/components/base/icons/index.js